export const catalog_matrix = [
  {form_key:'workers_limit_id', catalog_key:'worker_limits'},
  {form_key:'payroll_responsible_id', catalog_key:'none', propname:'users'},
  {form_key:'analyst_id', catalog_key:'none', propname:'users'},
  {form_key:'supervisor_id', catalog_key:'none', propname:'users'},
]